<template>

<div class="file-form">
    <div class="upload-box" :class="{'invalid': invalid}" >
        <i class="fa fa-paperclip"></i>
        <div class="loading animated fadeIn" v-if="uploading" >
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
        <p v-if="value && value.filename">{{value.filename}}.{{value.extension}}</p> 
        <p v-else class="placeholder">{{placeholder}}</p> 
        <input type="file" @change="upload" ref="file">
        <div class="invalid-feedback d-block" v-if="invalid">{{invalidText}}</div>
    </div>
</div>
</template>

<script>
import { uploadFileToGcs } from '@/lib/gcsUpload'

export default {
	name: "uploadFiles",
	props:{
		value:{
            type: Object,
        },
		placeholder: {
            type: String
        },
		invalid: {
            type: Boolean
        },
        invalidText: {
            type: String,
            default: 'Debe subir un archivo válido'
        },
    },
    data() {
        return {
            uploadedImage:{},
            uploading:false,
            file: null,
            backgroundImage: null,
            API_URL: process.env.VUE_APP_API_URL,
            filetypes: [
                'doc',
                'docx',
                'xls',
                'xlsx',
                'ppt',
                'pdf',
                'zip',
                'rar',
                '7z',
                'odt',
                'ods',
            ],
            imagetypes: [
                'gif',
                'png',
                'jpeg',
                'jpg',
            ]
        }
    },
	methods:{
        checkFile(file){
            if(file){
                var filename = file.name.split(".")
                var extension = filename[filename.length-1].toLowerCase()

                if( this.accept == 'image' && this.imagetypes.includes(extension)){
                    return true
                }
                if( this.accept == 'file' && this.filetypes.includes(extension)){
                    return true
                }
                // si no esta especificado que debe aceptar, me fijo si al menos es un formato aceptado.
                if( !this.accept && ( this.imagetypes.includes(extension) || this.filetypes.includes(extension)) ){
                    return true
                }
            }
            return false
        },

		upload(event){
            console.log(event)
            var input = event.target;
            if( this.checkFile(input.files[0]) ){
                this.uploading = input.files[0];
                this.uploading.thumb = URL.createObjectURL(input.files[0]);
                return uploadFileToGcs(this.$apollo, input.files[0])
                .then( file => {
                    if(file){
                        this.$emit('input', file)
                        this.$emit('uploaded', file)
                    }else{
                        this.$toast.error('Error al subir el archivo')
                    }
                    this.uploading = null;
                    return file;
                })
                .catch(err => {
                    console.log(err)
                    this.uploading= null;
                    return false;
                });
            }else{
                this.$toast.error('Archivo no permitido')
            }
		},
		remove(image){
			this.images.forEach( (existentImage, index) => {
				if( image.id == existentImage.id){
					this.$emit('deleted',index);
				}
			});
		},
	}
};
</script>

<style scoped lang="scss">
.file-form{
    width: 100%;
    display: flex;

    .upload-box{
        border: 1px solid #cde;
        border-radius: 3px;
        height: 38px;
        position:relative;
        display: flex;
        align-items: center;      
        background-color: #fff; 
        flex-grow: 1;
        cursor: pointer;

        .fa-paperclip{
            margin: 0px 8px;
            color: #adb5bd;
        }
        input{
            opacity:0;
            position: absolute;
            z-index: 10;
            top: 0px;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
        p{
            font-size: 12px;
            font-weight: 500;
            margin: 0px;
        }
        &.placeholder{
            color: #adb5bd;
        }
        
        &.invalid{
            border-color: #dc3545;
        }
    }
    &:hover{
        background-color: #f1f1f1; 
    }
    .invalid-feedback{
        position: absolute;
        bottom: -22px;
    }

    .loading{
        position: absolute;
        border:none;
        width: 100%;
        height: 100%;
        background-color: rgba(255,255,255,0.4); 
        display: flex;
        align-items: center;
        justify-content:flex-end;
        
        opacity: 1;
        cursor: pointer;

        i{
            font-size: 14px;
            margin: 0px 8px;
        }
    }
    
}

</style>
